/* assets/variant-media-filter.js (Horizon-safe: no DOM moving) */
(() => {
  const slugify = (str) =>
    (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

  const getVariantFromDOM = (root) => {
    const idInput =
      root.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');

    const variantId = idInput ? idInput.value : null;

    const jsonEl =
      root.querySelector("variant-selects script[data-variant]") ||
      root.querySelector("variant-radios script[data-variant]") ||
      document.querySelector("variant-selects script[data-variant]") ||
      document.querySelector("variant-radios script[data-variant]");

    if (!jsonEl || !variantId) return null;

    try {
      const variants = JSON.parse(jsonEl.textContent || "[]");
      return variants.find((x) => String(x.id) === String(variantId)) || null;
    } catch {
      return null;
    }
  };

  const pickHandleFromVariant = (variant) => {
    if (!variant) return null;
    const candidates = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    const qty = candidates.find((x) => /gummies/i.test(x)) || candidates[0];
    return slugify(qty); // "60-gummies"
  };

  // read tag from data attr if present, else fallback to img alt
  const readTag = (el) => {
    const ds = (el?.dataset?.mediaAltHandle || "").trim().toLowerCase();
    if (ds) return ds;
    const img = el ? el.querySelector("img") : null;
    return ((img?.getAttribute("alt") || "").trim().toLowerCase());
  };

  const setVisible = (el, yes) => {
    if (!el) return;
    if (yes) {
      el.classList.remove("vmf-hidden");
      el.removeAttribute("hidden");
      el.style.display = "";
      el.setAttribute("aria-hidden", "false");
    } else {
      el.classList.add("vmf-hidden");
      el.setAttribute("hidden", "hidden");
      el.style.display = "none";
      el.setAttribute("aria-hidden", "true");
    }
  };

  const apply = (sectionRoot) => {
    const gallery = sectionRoot.querySelector("media-gallery");
    if (!gallery) return;

    const sectionId = sectionRoot.getAttribute("data-section-id") || "";
    if (sectionId) gallery.dataset.sectionId = sectionId;

    const slideList = gallery.querySelector(".product__media-list");
    const thumbList = gallery.querySelector(".thumbnail-list");

    const slides = Array.from(gallery.querySelectorAll(".product__media-list > li.product__media-item"));
    const thumbs = Array.from(gallery.querySelectorAll(".thumbnail-list > li.thumbnail-list__item"));

    const variant = getVariantFromDOM(sectionRoot);
    const handle = pickHandleFromVariant(variant); // "60-gummies" etc.

    // 1) FILTER: show matching handle + common(blank/common)
    const isMatch = (el) => {
      const tag = readTag(el);
      if (!tag || tag === "common") return true; // common
      if (!handle) return true; // if variant not detected, show all
      return tag === handle;
    };

    slides.forEach((li) => setVisible(li, isMatch(li)));
    thumbs.forEach((li) => setVisible(li, isMatch(li)));

    // 2) VISUAL ORDER (NO DOM MOVE)
    // Requirement: 4 variant images first, then common images as 5/6/7
    // We'll set CSS 'order' on visible items:
    //   variant-specific => order 1..999
    //   common => order 5000..5999
    // Hidden items => order 999999
    const visibleSlides = slides.filter((li) => li.style.display !== "none");
    const visibleThumbs = thumbs.filter((li) => li.style.display !== "none");

    // Variant-specific first
    let variantIndex = 0;
    let commonIndex = 0;

    visibleSlides.forEach((li) => {
      const tag = readTag(li);
      const isCommon = !tag || tag === "common";
      if (isCommon) {
        commonIndex += 1;
        li.style.order = String(5000 + commonIndex);
      } else {
        variantIndex += 1;
        li.style.order = String(100 + variantIndex);
      }
    });

    variantIndex = 0;
    commonIndex = 0;

    visibleThumbs.forEach((li) => {
      const tag = readTag(li);
      const isCommon = !tag || tag === "common";
      if (isCommon) {
        commonIndex += 1;
        li.style.order = String(5000 + commonIndex);
      } else {
        variantIndex += 1;
        li.style.order = String(100 + variantIndex);
      }
    });

    // 3) Rebuild data-media-position in the *new visual order* (sorted by order)
    // This is CRITICAL for Horizon click behavior.
    const getOrder = (el) => parseInt(el.style.order || "0", 10);

    const sortedSlides = visibleSlides.slice().sort((a, b) => getOrder(a) - getOrder(b));
    const sortedThumbs = visibleThumbs.slice().sort((a, b) => getOrder(a) - getOrder(b));

    sortedSlides.forEach((li, idx) => {
      // slide doesn't always have data-media-position, but ok to set
      li.dataset.mediaPosition = String(idx + 1);
    });

    sortedThumbs.forEach((li, idx) => {
      li.setAttribute("data-media-position", String(idx + 1));
    });

    // 4) Ensure ACTIVE main media is visible and working:
    // - If current active slide is hidden OR no active, activate the first visible slide
    const activeSlide = gallery.querySelector(".product__media-item.is-active");
    const activeHidden = activeSlide && activeSlide.style.display === "none";

    const firstVisibleSlide = sortedSlides[0] || null;
    if (!firstVisibleSlide) return;

    const target = firstVisibleSlide.getAttribute("data-media-id");
    if (!target) return;

    const selectByThumbClick = () => {
      const thumbLi = sortedThumbs.find((t) => t.getAttribute("data-target") === target) || null;
      const btn = thumbLi ? thumbLi.querySelector("button.thumbnail") : null;
      if (btn) btn.click();
    };

    if (!activeSlide || activeHidden) {
      // reset active class for CSS
      slides.forEach((li) => li.classList.remove("is-active"));
      firstVisibleSlide.classList.add("is-active");

      // Sync aria-current
      thumbs.forEach((t) => {
        const btn = t.querySelector("button.thumbnail");
        if (!btn) return;
        if (t.getAttribute("data-target") === target && t.style.display !== "none") {
          btn.setAttribute("aria-current", "true");
        } else {
          btn.removeAttribute("aria-current");
        }
      });

      // Horizon-safe: always click to let theme render correct large image
      selectByThumbClick();
    }
  };

  const init = (sectionRoot) => {
    if (!sectionRoot) return;

    // Run after Horizon scripts settle
    const run = () => apply(sectionRoot);

    // initial
    setTimeout(run, 200);

    // On variant change
    sectionRoot.addEventListener(
      "change",
      (e) => {
        if (
          e.target.closest("variant-selects") ||
          e.target.closest("variant-radios") ||
          e.target.matches('input[name="id"]')
        ) {
          setTimeout(run, 200);
        }
      },
      true
    );

    // Fallback events
    document.addEventListener("variant:change", () => setTimeout(run, 200));
    document.addEventListener("variantChange", () => setTimeout(run, 200));

    // Horizon often re-renders media → re-apply
    const gallery = sectionRoot.querySelector("media-gallery");
    if (gallery) {
      const mo = new MutationObserver(() => setTimeout(run, 120));
      mo.observe(gallery, { childList: true, subtree: true });
    }

    window.addEventListener("load", () => setTimeout(run, 200));
  };

  const boot = () => {
    document.querySelectorAll('[data-section-type="main-product"]').forEach(init);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();